"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactHotLoader = require("react-hot-loader");

var _Page = require("../../components/Layout/Page");

var _tenant = require("../../utils/tenant");

var _default = (0, _reactHotLoader.hot)(module)(() => {
  const profileUrl = (0, _tenant.useApertureUrl)('/settings/profile');
  (0, _react.useEffect)(() => {
    window.location.href = profileUrl;
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Page.Wrap, null);
});

exports.default = _default;
module.exports = exports.default;